import Vue from "vue";
import Main from "./main.vue";

let LoadingConstructor = Vue.extend(Main);
let instance;
let renderLoading = false;

const Loading = {};
Loading.render = function(options) {
  options = options || {};
  if (!renderLoading) {
    instance = new LoadingConstructor();
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }
  renderLoading = true;
  instance.mode = options.mode || "fullscreen";
  options.color && (instance.color = options.color);
  options.size && (instance.size = options.size);
  options.autoSize && (instance.autoSize = options.autoSize);
  options.mask && (instance.mask = options.mask);
  instance.dom = instance.vm.$el;
  return instance.vm;
};
Loading.hide = () => {
  instance.show = false;
};
Loading.show = () => {
  instance.show = true;
};
Loading.render();
export default Loading;
